import { IFontStyles, ITextStyles, Stack, Text } from '@fluentui/react';
import React from 'react';
import { CollapseToggleIcon } from '../../shared/CollapseToggleIcon';

const titleStyles: ITextStyles = {
  root: {
    fontWeight: 'normal'
  }
};

export interface CollapsableSectionProps {
  displayName: string;
  className?: string;
  backgroundColor?: string;
  variant?: keyof IFontStyles;
}

interface CollapsableSectionState {
  isCollapsed: boolean;
}

export interface CollapsableSectionStyle {
  root: React.CSSProperties;
}

export class CollapsableSection extends React.PureComponent<CollapsableSectionProps, CollapsableSectionState> {
  state: CollapsableSectionState = {
    isCollapsed: true
  };

  render(): JSX.Element {
    const sectionStyle: React.CSSProperties = {
      backgroundColor: this.props.backgroundColor
    };

    return (
      <React.Fragment>
        <Stack horizontal className={this.props.className} style={sectionStyle}>
          <Stack.Item>
            <CollapseToggleIcon
              isCollapsed={this.state.isCollapsed}
              onClick={(): void =>
                this.setState({
                  isCollapsed: !this.state.isCollapsed
                })
              }
            />
          </Stack.Item>
          <Stack.Item align="center">
            <Text variant={this.props.variant} styles={titleStyles}>
              {this.props.displayName}
            </Text>
          </Stack.Item>
        </Stack>
        <div hidden={!this.state.isCollapsed}>{this.props.children}</div>
      </React.Fragment>
    );
  }
}
